export interface PptSlide {
  title: string;
  layout?: LayoutStyles;
  content?: SlideContent;
}

export interface ContentObject {
  title?: string;
  image?: string;
  content: string;
}

export interface ContentItem {
  content: string;
}

export enum LayoutStyles {
  DEFAULT = 'default',
  CENTERED_FOCUS = 'centeredFocus',
  QUADRANT = 'quadrant',
  COMPARISON = 'comparison',
  LEFT_CONTENT = 'leftContent',
  RIGHT_CONTENT = 'rightContent',
  HORIZONTAL_SPLIT = 'horizontalSplit',
  VERTICAL_SPLIT = 'verticalSplit',
}

export type SlideContent =
  | string
  | ContentObject
  | ContentItem[]
  | ContentObject[];

export type ContentFormatter = (
  contentValue: SlideContent | undefined
) => string | { content: string; image?: string };